import React, { memo } from 'react';
import HeaderTypography from 'components/Common/HeaderTypography';
import QABar from './QABar';
import Styles from './index.module.css';

function FQA() {
  return (
    <div className={Styles.FQAContainer}>
      <div className={Styles.leftContent} />
      <div className={Styles.midContent}>
        <HeaderTypography>常見問題</HeaderTypography>
        <QABar title="How does publishing work?"> A</QABar>
        <QABar title="Does galaxy do design work?">B</QABar>
        <QABar title="How does publishing work?">C</QABar>
        <QABar title="Does galaxy do design work?">D</QABar>
        <QABar title="Does galaxy do design work?">E</QABar>
        <QABar title="How does publishing work?">F</QABar>
      </div>
      <div className={Styles.rightContent} />
    </div>
  );
}

export default memo(FQA);
